import { flow, makeObservable, observable } from 'mobx';
import BaseStore from './BaseStore';
import { SettingTopPageApi } from '../apis';
import { SYSTEM_PATH } from '../core/configs/constants';

class SettingTopPageStore extends BaseStore {

    themeTopPage = undefined;
    isPreview = window.location.pathname === SYSTEM_PATH.HOME_PREVIEW;

    constructor(rootStore) {
        super();
        makeObservable(this, {
            themeTopPage: observable,
            getThemeTopPage: flow.bound
        })
        this.rootStore = rootStore;
        this.api = new SettingTopPageApi();
    }

    *getThemeTopPage(typeTheme) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getThemeTopPage, typeTheme);
            if (res?.ok) {
                this.themeTopPage = res?.data;
                return true;
            }
            return false;
        } catch (error) {
            console.error(error);
        }
    }

    clean() {
        super.clean();
        this.themeTopPage = undefined;
        this.isPreview = false;
    }
}

export default SettingTopPageStore;
